<template>
    <span :style="{'text-align': 'center', 'display': small? 'inline-block' : 'block', 'z-index': zIndex, 'color': color ? 'black' : color}" v-bind:class="{'large-loading-container': !small, 'small-loading-container': small}" >
      <div v-if="!small" class="large-loader">
        <div class="loader"></div>
        <span class="loading-text noselect">{{text}}</span>
      </div>
      <div v-else class="small-loader">
        <div class="loader"></div>
      </div>
    </span>
</template>

<script>
    export default {
        name: 'Loading',
        props: ['text', 'small', 'zIndex', 'color']
    }
</script>

<style lang="scss">
@import "src/css/vars.scss";

.large-loading-container {
  position: absolute;
  width: 100%;
  left: 0;
}

.loading-text {
  position: relative;
  top: -20px;
  left: 10px;
  font-weight: 500;
}

.loader {
  border-radius: 50%;
  display: inline-block;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* https://loading.io */
/* LARGE */
.large-loader {
  text-align: center; 
  margin: 30px auto;

  .loader {
    display: inline-block;
    width: 48px;
    height: 48px;
    margin-right: 10px;

    border: 6px solid $border-color;
    border-top: 6px solid $primary-color;
  }
}

/* SMALL */
.small-loader {
  .loader {
    width: 24px;
    height: 24px;
    margin-right: 10px;
    border: 3px solid $border-color;
    border-top: 3px solid $primary-color;
  }
}
</style>